/**
 * Default-skin color tokens for the editor (from the Outlook plugin's Figma Make
 * prototype). Kept package-local so the editor has no dependency on a consumer's
 * palette; theming hooks come when packages/main adopts the editor.
 */
export const gray200 = '#E5E7EB';
export const gray500 = '#6B7280';
export const gray700 = '#374151';
export const inputBackground = '#F3F3F5';
export const mutedForeground = '#717182';
export const white = '#FFF';
